import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../../hooks/useMediaQuery';

export function PageLoader() {
  const isMobile = useIsMobile();

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-50 to-purple-50 flex flex-col items-center justify-center z-50 p-4">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="text-center w-full max-w-sm"
      >
        {/* Logo fijo con pulso sutil */}
        <motion.div
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className={`inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl mb-4 mx-auto ${
            isMobile ? 'w-16 h-16' : 'w-24 h-24'
          }`}
        >
          <img 
            src="/favicon/favicon-96x96.png" 
            alt="PropZyn" 
            className={isMobile ? 'w-8 h-8' : 'w-12 h-12'}
          />
        </motion.div>
        
        <h2 className={`font-bold text-gray-800 mb-2 ${
          isMobile ? 'text-xl' : 'text-2xl'
        }`}>
          PropZyn
        </h2>
        <p className={`text-gray-600 mb-6 ${
          isMobile ? 'text-sm' : 'text-base'
        }`}>
          {isMobile ? 'Carregando...' : 'Carregando sua experiência...'}
        </p>
        
        {/* Barra de progreso animada */}
        <div className={`bg-gray-200 rounded-full overflow-hidden mx-auto ${
          isMobile ? 'w-40 h-1.5' : 'w-48 h-2'
        }`}>
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: '100%' }}
            transition={{ 
              duration: 1.5, 
              repeat: Infinity,
              ease: "easeInOut" 
            }}
            className="h-full bg-gradient-to-r from-blue-500 to-purple-500 w-1/2"
          />
        </div>
      </motion.div>
    </div>
  );
}